import React from "react";
import {
  ModalLayout,
  Pagination,
  SearchFilters,
} from "@wac-ui-dashboard/wac_component_library";
import { FaSort } from "react-icons/fa";
import { Table } from "../../../Global/Table";
import useApprovedDetails from "./useApprovedDetails";
import ExcelUpload from "./ExcelUpload";
import Style from "../../verifications.module.scss";

const ApprovedDetails = ({
  receiptId,
  gliNumber,
  officeSlipRef,
  StockReceiptRef,
}) => {
  const {
    search,
    isFetching,
    tableFields,
    certificateList,
    currentPage,
    paginationOptions,
    showExcelUploadModal,
    getRow,
    refetch,
    handleSearch,
    handleClearClick,
    handlePageSize,
    handlePagination,
    handleExcelFileUpload,
    handleExcelFileDownload,
    handleOfficeSlipPrint,
    handleStockReceiptPrint,
  } = useApprovedDetails({
    receiptId,
    gliNumber,
    officeSlipRef,
    StockReceiptRef,
  });

  return (
    <div className="pro-w-100">
      <div className={`pro-mb-5 ${Style.head}`}>
        <h5 className="pro-ttl h5 pro-mb-2">{gliNumber}</h5>
        <div className={Style.btns}>
          <button
            className={`pro-btn pro-items-center pro-btn-outline`}
            onClick={handleExcelFileDownload}
          >
            <span className="material-symbols-outlined">download</span>
            <span>Excel Download</span>
          </button>
          <button
            className={`pro-btn pro-items-center pro-btn-outline`}
            onClick={handleExcelFileUpload}
          >
            <span className="material-symbols-outlined">upload</span>
            <span>Excel Upload</span>
          </button>
          <button
            className={`pro-btn pro-items-center pro-btn-outline`}
            onClick={handleStockReceiptPrint}
          >
            <span className="material-symbols-outlined">list_alt</span>
            <span>Print Stock Receipt</span>
          </button>
          <button
            className={`pro-btn pro-items-center pro-btn-outline`}
            onClick={handleOfficeSlipPrint}
          >
            <span className="material-symbols-outlined">apartment</span>
            <span>Print Office Slip</span>
          </button>
        </div>
      </div>

      <SearchFilters
        onSearchInput={handleSearch}
        showActions={false}
        SearchIcon={<span className="material-symbols-outlined"> search </span>}
        showClearFilters
        handleClear={handleClearClick}
        searchInputProps={{
          value: search,
          placeholder: "Search Certificate Number",
        }}
      />

      <Table
        multiSelect={false}
        data={certificateList?.data?.data || []}
        uniqueID={"id"}
        fields={tableFields}
        showCheckBox={false}
        SortIcon={<FaSort />}
        handleSort={() => {}}
        getRow={getRow}
        loading={isFetching}
        perpage={10}
        assignable={false}
        editable={false}
        deletable={false}
        extraClasssName={`pro-pb-6`}
      />

      <Pagination
        currentPage={currentPage}
        totalPageCount={Math.ceil(
          certificateList?.data?.total_count / certificateList?.data?.per_page
        )}
        onPageChange={handlePagination}
        options={paginationOptions}
        onActionChange={handlePageSize}
        center
      />

      <ModalLayout
        show={showExcelUploadModal}
        handleClose={handleExcelFileUpload}
        title={"Excel Upload"}
        closeIcon={<span className="material-symbols-outlined"> close </span>}
      >
        <div className="pro-m-5">
          <ExcelUpload
            receiptId={receiptId}
            handleClose={handleExcelFileUpload}
            onUploaded={refetch}
          />
        </div>
      </ModalLayout>
    </div>
  );
};

export default ApprovedDetails;
